/* Copyright (c) 2021-2025, NVIDIA CORPORATION.  All rights reserved.
 *
 * NVIDIA CORPORATION and its licensors retain all intellectual property
 * and proprietary rights in and to this software, related documentation
 * and any modifications thereto.  Any use, reproduction, disclosure or
 * distribution of this software and related documentation without an express
 * license agreement from NVIDIA CORPORATION is strictly prohibited.
 */

import { Injectable, InjectionToken } from '@angular/core';
import { SpatialNavigationConfig } from './services/spatial-navigation/spatial-navigation.types';
import { UserActivationType } from './services/user-activation-guard/user-activation-guard.interface';

export interface UserActivationGuardConfiguration {
    link?: UserActivationType;
    input?: UserActivationType;
    playMedia?: UserActivationType;
    share?: UserActivationType;
    linkWarningMessage?: string;
    buttonWarningMessage?: string;
}

export interface NvHigOffDeviceLinkConfig {
    title: string;
    primaryButtonText: string;
}

@Injectable()
export class NvHigConfig {
    offDeviceLinkConfig?: NvHigOffDeviceLinkConfig;
    tvMode?: boolean;
    focusRippleBorderWidth?: number;
    showQRCodeForLinks?: boolean;
    mobileMode?: boolean;
    focusRippleEnabled?: boolean;
    spatialNavigationConfig?: SpatialNavigationConfig;
    userActivationGuardConfig?: UserActivationGuardConfiguration;
    /** flag to indicate that the screen reader clears the focus when the accessibility highlight is moved to the next accessibility focusable item
     * this is known to be the case on android tv with which uses talkback as it's screen reader.
     */
    screenReaderFocusClearWorkaround?: boolean;
    customClickHandler?: (element: HTMLElement) => void;
    syntheticClickHandler?: (element: HTMLElement) => void;
}

export const NV_HIG_CONFIG = new InjectionToken<NvHigConfig>('NV_HIG_CONFIG');
